export default __webpack_public_path__ + "static/media/background.ed2d533c.jpg";